<template>
  <div class="comment-block--components row-flex">
    <div @click="goPersonal" > 
      <Avatar class="avatar" :size="20" :src="info.Avatar"></Avatar>
    </div>
    
    <div class="member-info row-flex-eq">
      <div class="title row-flex">
        <div class="row-flex-eq row-flex" @click="goPersonal">
          <div class="username ellipsis">{{info.UserName}}</div>
          <div>
            <span class="item-text author-icon" v-if="info.UserId == articleAuthorId">作者</span>
          </div>
        </div>
        <goodBtn v-model="info.isGood" :sourceId="info.Id" :goodCount="info.GoodNum" :commentGoodId='info.CommentGoodId' type='comment'/>
      </div>
      <div class="content">
        <div class="comment-content">
          <div v-if="info.Deleted" class="text-gray">该评论已删除</div>
          <flodSpan v-else :content='info.Content'></flodSpan>
        </div>
        <div class="comment-img-box" v-if="info.ImgList && info.ImgList.length">
          <previewImg v-for="(comImg,idx) in info.ImgList" :key="idx" class="comment-img" :imgUrl="comImg" />
        </div>
        <div class="comment-footer">
          <span class="comment-time text-gray">{{info.ModifiedTime | datetime-parse}} · </span>
          <span
            v-if="!notShowReplay"
            class="comment-btn"
            @click="sendComment(info)"
            :class="{bg: info.Children.length}"
          >{{info.Children.length? info.Children.length : ''}}回复</span>
        </div>
        <!-- 楼中楼 -->
        <div class="sub-comment-list" v-if="!noSubitem && info.Children && info.Children.length">
          <subCommentBlock
            v-for="cItem in minChildren"
            :key="cItem.Id"
            :articleAuthorId='articleAuthorId'
            :info="cItem"
            />
          <div v-if="info.Children.length > maxChildrenCount">
            <div class="show-more-item text-blue" v-if="isShowAllBtn" @click="showAll">{{`查看全部${info.Children.length}条回复`}} </div>
            <div class="show-more-item text-blue" v-else @click="initData">收起</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import goodBtn from "@/components/article/goodBtn.vue";
import Avatar from "@/components/avatar";
import subCommentBlock from '@/components/comment/subCommentBlock.vue'
import flodSpan from '@/components/comment/flodSpan.vue'
import previewImg from '@/components/common/previewImg.vue'
export default {
  name: 'CommentBlock',
  props: {
    articleAuthorId: {
      type: Number,
      required: true
    },
    noSubitem: {
      type: Boolean,
      default: false
    },
    notShowReplay: {
      type: Boolean,
      default: false,
    },
    info: {
      required: true,
      default: () => {
        return {
          Id: 0,
          AppId: 0,
          Module: "",
          SourceId: "",
          Content: "",
          ParentId: 0,
          UserId: 0,
          UserName: "",
          Avatar: "",
          GoodNum: 0,
          RecommendNum: 0,
          AbuseNum: 0,
          Creator: 0,
          CreateTime: "",
          Modifier: 0,
          ModifiedTime: "",
          Deleted: false,
          ImgList: [],
          ReplyCount: 0,
          AuthorId: 0,
          Children: [],
        };
      }
    }
  },
  components: {
    goodBtn,
    Avatar,
    subCommentBlock,
    flodSpan,
    previewImg
  },
  watch: {
    'info.Children': function() {
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  data() {
    return {
      maxChildrenCount: 1,
      maxContentLength: 100,
      isShowAllBtn: true,
      minChildren: [],
    };
  },
  methods: {
    sendComment(info) {
      this.$emit('childrenComment', info)
    },
    initData() {
      if (this.info.Children && this.info.Children.length) {
        this.minChildren = this.info.Children.filter((item, idx) => idx < this.maxChildrenCount)
        this.isShowAllBtn = true
      }
    },
    showAll() {
      this.isShowAllBtn = false
      this.minChildren= this.info.Children
      // this.$emit('showAllComment',this.info )
    },
    handlechildComment(Id) {
      this.sendComment(Id)
    },
    goPersonal() {
      this.$router.push({name:'personal',params:{id:this.info.UserId}})
    },
  }
};
</script>
<style lang='scss' scoped>
.comment-block--components {
  padding: 15px 0;
  color: $text-main;

  & + & {
    border-top: 1px solid $border-color;
  }
  .username {
    padding-right: 8px;
    max-width: 150px;
  }
  .avatar {
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }
  .member-info {
    
    .title {
      font-size: $font-size-big;
      line-height: 36px;
      margin-bottom: 12px;
    }
    .content {
      font-size: $font-size-normal;
    }
  }
  
  .comment-img-box {
    display: flex;
    flex-wrap: wrap;
    margin-right: -12px;
    max-width: 220px;
    margin-top: 12px;

    .comment-img {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      margin-bottom: 12px;
    }
  }
  .comment-footer {
    margin-bottom: 16px;
  }
  .sub-comment-list {
    background: #F9F9F9;
    border-radius: 3px;
    padding: 12px;
    
  }
  .show-more-item, .comment-btn {
    
    font-size: $font-size-small;
  }
  .good-btn {
    color: $gray-deep-more;
  }
  .comment-btn {
    display: inline-block;
    line-height: 24px;
    padding: 0 12px;

    &.bg {
      background: $gray;
      border-radius: 100px;
    }
  }
  .author-icon {
    font-size: 12px;
    border-radius:3px;
    line-height: 24px;
    padding: 0 3px;
    color: $red;
    border: 1px solid $red;
  }
}
</style>
